"use strict";
require('../CompanyPublicationService.js');
require('./CompanyPublicationOrderService.js');
require('../plant/CompanyPublicationPlantService.js');
require('../../users/CompanyUserService.js');
require('../../projects/CompanyProjectService.js');

CompanyPublicationOrderCtrl.$inject = ['$scope',
                                      '$stateParams',
                                      '$state',
                                      '$q',
                                      'CompanyPublicationService',
                                      'CompanyPublicationOrderService',
                                      'CompanyPublicationPlantService',
                                      'CompanyUserService',
                                      'CompanyProjectService',
                                      '$translate',
                                      'growl'];
function CompanyPublicationOrderCtrl($scope,
                                    $stateParams,
                                    $state,
                                    $q,
                                    publicationService,
                                    orderService,
                                    plantService,
                                    userService,
                                    projectService,
                                    $translate,
                                    growl) {

  $scope.orderPlants = [];
  $scope.orderUsers = [];
  $scope.orderProjects = [];

  if ($scope.order) {
    var params = {
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      massoptimeringId: $scope.order.id
    };

    var orderPlants = orderService.queryPlants(params).$promise;
    var orderUsers = orderService.queryUsers(params).$promise;
    var orderProjects = orderService.queryProjects(params).$promise;

    $q.all([orderPlants, orderUsers, orderProjects]).then(function(data){
      $scope.orderPlants = data[0];
      $scope.orderUsers = data[1];
      $scope.orderProjects = data[2];
    });
  }

  $scope.queryObjects = function(text, type) {
    switch (type) {
      case 'plant':
        return publicationService.query({
            companyId: $stateParams.companyId,
            q:         text,
            type: 'PLANT',
            limit:     10
          }).$promise.then(function(pubs) {
            return pubs.filter(function(p) {
              return !$scope.orderPlants.some(function(plant) {
                return plant.id === p.features.currentPlantId;
              });
            });
          });
      case 'user':
        return userService.query({
          companyId: $stateParams.companyId,
          limit: 10,
          email: text
        }).$promise.then(function(users){
          return users.filter(function(u){
            return !$scope.orderUsers.some(function(user){
              return user.id === u.id;
            });
          });
        });
      case 'project':
        return projectService.query({
          companyId: $stateParams.companyId,
          name: text,
          limit: 10
        }).$promise.then(function(projects){
          return projects.filter(function(project){
            return !$scope.orderProjects.some(function(p){
              return project.id === p.id;
            });
          });
        });
    }
  };

  $scope.addObject = function(obj, type) {
    var params = {
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      massoptimeringId: $scope.order.id
    };
    switch (type) {
      case 'plant':
        orderService.addPlant(
          params,
          {'id': obj.features.currentPlantId}, function(resp) {
          plantService.get({
            companyId: $stateParams.companyId,
            publicationId: obj.id,
            plantId: resp.id
          }).$promise.then(function(resp){
            resp.publication = {
              name: obj.name,
              id: obj.id
            };

            $scope.orderPlants.push(resp);
            growl.addSuccessMessage($translate.instant('order.plant.add-success'));
          });
        }, function(){
          growl.addErrorMessage($translate.instant('order.plant.add-failure'));
        });
        break;
      case 'user':
        orderService.addUser(
          params,
          {'id': obj.id})
        .$promise
        .then(function(){
          $scope.orderUsers.push(obj);
          growl.addSuccessMessage($translate.instant('order.user.add-success'));
        }, function(){
          growl.addErrorMessage($translate.instant('order.user.add-failure'));
        });
        break;
      case 'project':
        orderService.addProject(
          params,
          {'id': obj.id})
        .$promise
        .then(function(){
          $scope.orderProjects.push(obj);
          growl.addSuccessMessage($translate.instant('order.project.add-success'));
        }, function(){
          growl.addErrorMessage($translate.instant('order.project.add-failure'));
        });
        break;
    }
  };

  $scope.removeObject = function(id, index, type){
    var params = {
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      massoptimeringId: $scope.order.id,
      id: id
    };

    switch (type) {
      case 'plant':
        orderService.removePlant(params)
                    .$promise
                    .then(function(){
                      $scope.orderPlants.splice(index, 1);
                      growl.addSuccessMessage($translate.instant('order.plant.remove-success'));
                    }, function(){
                      growl.addErrorMessage($translate.instant('order.plant.remove-failure'));
                    });
        break;
      case 'user':
        orderService.removeUser(params)
                    .$promise
                    .then(function(){
                      $scope.orderUsers.splice(index, 1);
                      growl.addSuccessMessage($translate.instant('order.user.remove-success'));
                    }, function(){
                      growl.addErrorMessage($translate.instant('order.user.remove-failure'));
                    });
        break;
      case 'project':
        orderService.removeProject(params)
                    .$promise
                    .then(function(){
                      $scope.orderProjects.splice(index, 1);
                      growl.addSuccessMessage($translate.instant('order.project.remove-success'));
                    }, function(){
                      growl.addErrorMessage($translate.instant('order.project.remove-failure'));
                    });
        break;
    }
  };
}

angular.module("dokiv")
  .controller("CompanyPublicationOrderCtrl", CompanyPublicationOrderCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/order/CompanyPublicationOrderCtrl.js
// module id = 402
// module chunks = 0